module.exports = __webpack_public_path__ + "static/your_goals_your_plan_mobile-7d3619b09061d0bae6128747936c01ec.jpg";